module.exports = __webpack_public_path__ + "static/media/azimut-icons.7fc50384.woff";